import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { ParameterGroup } from "../models/parameter-group";
import { FilterParameterGroup } from "../models/filters/filter-parameter-group";

@Injectable({
providedIn: 'root'
})
export class ParameterGroupService {

    constructor(private http: HttpClient) { }

    private apiUrl = `${environment.apiUrl}`;
    private url: string = this.apiUrl + 'api/parameters';

    findAllPageableParameterGroup(filterParameterGroup: FilterParameterGroup, page: number, pageSize: number): Observable<any> {
        return this.http.post<any[]>(`${this.url}/page/${page}/${pageSize}`, filterParameterGroup);
    }
    
    findParameterGroupById(id: number): Observable<ParameterGroup> {
        return this.http.get<ParameterGroup>(`${this.url}/${id}`);
    }

}